module.exports = __webpack_public_path__ + "img/banner2.8d2c5710.jpg";